var React = require('react');

function Radio (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 128H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zM80 248a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H88a8 8 0 0 1-8-8zm128 144a8 8 0 0 1-8 8H88a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h112a8 8 0 0 1 8 8zm16-64a8 8 0 0 1-8 8H72a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h144a8 8 0 0 1 8 8zm222.37 8.13a96 96 0 1 1 0-32.26 80.62 80.62 0 0 1 0 32.26z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M511.4 27.05l-4.33-15.38A16 16 0 0 0 487.33.6L64 128h147.5l288.83-81.21a16 16 0 0 0 11.07-19.74zM352 224a96 96 0 1 0 96 96 96 96 0 0 0-96-96zm0 144a48 48 0 1 1 48-48 48.05 48.05 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

Radio.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Radio;

Radio.default = Radio;
